export default __webpack_public_path__ + "d6e8ba100f2c503b27dadeb5477021ae.svg";